import { apiClient } from "../../Utils/apiClient";


class LicenseOverview {
    async removeCustomerLicense (accessToken: string, sessionToken: string, id: any): Promise<any> {
        return apiClient.delete(`remove-customer-license/${id}`, accessToken, sessionToken);
    }
    async getAllLicenseExpirations(accessToken: string, sessionToken: string, params: {
        page?: string,
        pageSize?: string,
        licenseName?: string,
        state?: string,
        warning?: string,
        warningOrderDir?: string
    }): Promise<any> {
        return apiClient.get("get-all-licenses-with-expiration", accessToken, sessionToken, params);
    }
}

const LicenseOverviewFunction = new LicenseOverview();

export default LicenseOverviewFunction;